import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { UserInterface } from '../../../core';
import { UserFunctions } from './user-functions';

@JsonObject('User')
export class User implements UserInterface {
    private readonly _ID_CAN_EDIT = '556';
    private readonly _ID_CAN_OPERATE = '553';
    private readonly _ID_CAN_SIGN = '552';

    @JsonProperty('UserId', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('UserCode', IdAdapter, true)
    private _code: Id = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('Surname', StringAdapter, true)
    private _surname: string = undefined;

    @JsonProperty('Functions', [UserFunctions], true)
    private _functions: UserFunctions[] = [];

    private _isAdmin = false;
    private _isAdminPBC = false;

    get id(): Id {
        return this._id;
    }

    get code(): Id {
        return this._code;
    }

    get name(): string {
        return this._name;
    }

    get surname(): string {
        return this._surname;
    }

    get isAdmin(): boolean {
        return this._isAdmin;
    }

    set isAdmin(value: boolean) {
        this._isAdmin = value;
    }

    get isAdminPBC(): boolean {
        return this._isAdminPBC;
    }

    set isAdminPBC(value: boolean) {
        this._isAdminPBC = value;
    }

    get functions(): UserFunctions[] {
        return this._functions;
    }

    get canEdit(): boolean {
        return !!(this.functions ? this.functions.find((x) => String(x.id) === this._ID_CAN_EDIT) : false);
    }

    get canOperate(): boolean {
        return !!(this.functions ? this.functions.find((x) => String(x.id) === this._ID_CAN_OPERATE) : false);
    }

    get canSign(): boolean {
        return true;
    }
}
